import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z"
}), 'FiberManualRecordOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FiberManualRecordOutlined.js
// module id = 3550
// module chunks = 2